import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import DeleteUserForm from "../deleteUserRequest";
import PrivacyPolicy from "../privacyCondition/privacyPolicy";
import TermOfCondition from "../privacyCondition/termOfCondition";
import FormScanQrCode from "../scanQrForm"
import Login from "./login";

import RithMonyPrivacyPolicy from "../privacyCondition/RithMonyPrivacyPolicy";
import RithMonyTermsCondition from "../privacyCondition/RithMonyTermsCondition";

export default function Auth() {
	return (
		<Switch>
			<Route path="/login" component={Login} />
			<Route path="/delete-user-request" component={DeleteUserForm} />
			<Route path="/privacy-policy" component={PrivacyPolicy} />
			<Route path="/terms-and-conditions" component={TermOfCondition} />
			<Route path="/form-scan-qrcode" component={FormScanQrCode} />

			<Route path="/privacy-policy-rmn" component={RithMonyPrivacyPolicy} />
			<Route path="/terms-conditions-rmn" component={RithMonyTermsCondition} />


			<Redirect to="/login" />
		</Switch>
	);
}
